import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusZoomOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFocusZoomOut"><Path d="M8.75 3H3V8.75H4.5V4.5H8.75V3Z" fill="currentColor"/><Path d="M21 3H15.25V4.5H19.5V8.75H21V3Z" fill="currentColor"/><Path d="M4.5 19.5V15.25H3V21H8.75V19.5H4.5Z" fill="currentColor"/><Path d="M21 21V15.25H19.5V19.5H15.25V21H21Z" fill="currentColor"/><Path d="M12.75 11.25V8H11.25V11.25H8V12.75H11.25V16H12.75V12.75H16V11.25H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusZoomOut;
